import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { AuthService } from '../authentication/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/App.state';
import { selectAuthToken } from 'src/app/store/reducers/authToken.reducer';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  appendToken: HttpRequest<any>;

  constructor(private auth: AuthService, private store: Store<AppState>) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.store.select(selectAuthToken).subscribe(token => {
      if (token && token.authToken) {
        req = this.addToken(token.authToken, req);
      } else {
        req = this.addToken(sessionStorage.getItem("clientToken"), req);
      }
    }
    );
    return next.handle(req);

  }

  addToken(data: any, req: HttpRequest<any>): HttpRequest<any> {
    return req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + data)

    });
  }
}
